__turbopack_context__.v({
  "copy": "j5d_EG_copy",
  "heroContent": "j5d_EG_heroContent",
  "heroOverlay": "j5d_EG_heroOverlay",
  "heroPanel": "j5d_EG_heroPanel",
  "heroSection": "j5d_EG_heroSection",
  "heroVideo": "j5d_EG_heroVideo",
  "subtitle": "j5d_EG_subtitle",
  "title": "j5d_EG_title",
});
